export default __webpack_public_path__ + "static/media/SitiNurArifah-img.4c0ff131.jpg";